/*
* 项目类型*/
const projectTypeArray = [
    {value: 1, label: '国外小组科研'},
    {value: 2, label: '国内1对1'},
    {value: 3, label: '国外1对1'},
    {value: 4, label: '名校实验室'},
    {value: 5, label: 'AI HUB'},
    {value: 6, label: '全球华人导师'},
    {value: 27, label: '博雅计划-在线'},
    {value: 30, label: 'IEPQ线上项目'},
    {value: 31, label: '竞赛'},
    {value: 32, label: '全球华人导师-香港'},
    {value: 38, label: '海外导师线下项目'},
    {value: 39, label: '国内导师线下项目'},
    {value: 40, label: '竞赛1v1'},
    {value: 42, label: 'IEPQ 1v1'},
    {value: 44, label: '全球华人导师-海外'},
    {value: 45, label: '企业导师远程实训'},
    {value: 47, label: '博雅计划-线下'},
    {value: 48, label: 'IEPQ 1v3'},
    {value: 49, label: '专业选修课'},
    {value: 50, label: 'IEPQ线下项目'},
    {value: 51, label: 'CERTIPORT认证课程'},
    {value: 52, label: '境外游学项目'},
    {value: 53, label: '竞赛线下（营地）'},
    {value: 54, label: '竞赛线下（研学）'},
    {value: 56, label: '全球在研'},
    {value: 57, label: 'Astra 1v1'},
    {value: 58, label: '国内升学产品'},
    {value: 55, label: '其他'},
    {value: 59, label: 'OPC智造局'},
    {value: 60, label: 'OPC智战枢'},
]

const projectTypeAllArray = [
    {value: '', label: '全部',},
    {value: 1, label: '国外小组科研'},
    {value: 2, label: '国内1对1'},
    {value: 3, label: '国外1对1'},
    {value: 4, label: '名校实验室'},
    {value: 5, label: 'AI HUB'},
    {value: 6, label: '全球华人导师'},
    {value: 27, label: '博雅计划-在线'},
    {value: 30, label: 'IEPQ线上项目'},
    {value: 31, label: '竞赛'},
    {value: 32, label: '全球华人导师-香港'},
    {value: 38, label: '海外导师线下项目'},
    {value: 39, label: '国内导师线下项目'},
    {value: 40, label: '竞赛1v1'},
    {value: 42, label: 'IEPQ 1v1'},
    {value: 44, label: '全球华人导师-海外'},
    {value: 45, label: '企业导师远程实训'},
    {value: 47, label: '博雅计划-线下'},
    {value: 48, label: 'IEPQ 1v3'},
    {value: 49, label: '专业选修课'},
    {value: 50, label: 'IEPQ线下项目'},
    {value: 51, label: 'CERTIPORT认证课程'},
    {value: 52, label: '境外游学项目'},
    {value: 53, label: '竞赛线下（营地）'},
    {value: 54, label: '竞赛线下（研学）'},
    {value: 56, label: '全球在研'},
    {value: 57, label: 'Astra 1v1'},
    {value: 58, label: '国内升学产品'},
    {value: 55, label: '其他'},
    {value: 59, label: 'OPC智造局'},
    {value: 60, label: 'OPC智战枢'},
]

const projectTypeZeroArray = [
    {value: 0, label: '全部',},
    {value: 1, label: '国外小组科研'},
    {value: 2, label: '国内1对1'},
    {value: 3, label: '国外1对1'},
    {value: 4, label: '名校实验室'},
    {value: 5, label: 'AI HUB'},
    {value: 6, label: '全球华人导师'},
    {value: 27, label: '博雅计划-在线'},
    {value: 30, label: 'IEPQ线上项目'},
    {value: 31, label: '竞赛'},
    {value: 32, label: '全球华人导师-香港'},
    {value: 38, label: '海外导师线下项目'},
    {value: 39, label: '国内导师线下项目'},
    {value: 40, label: '竞赛1v1'},
    {value: 42, label: 'IEPQ 1v1'},
    {value: 44, label: '全球华人导师-海外'},
    {value: 45, label: '企业导师远程实训'},
    {value: 47, label: '博雅计划-线下'},
    {value: 48, label: 'IEPQ 1v3'},
    {value: 49, label: '专业选修课'},
    {value: 50, label: 'IEPQ线下项目'},
    {value: 51, label: 'CERTIPORT认证课程'},
    {value: 52, label: '境外游学项目'},
    {value: 53, label: '竞赛线下（营地）'},
    {value: 54, label: '竞赛线下（研学）'},
    {value: 56, label: '全球在研'},
    {value: 57, label: 'Astra 1v1'},
    {value: 58, label: '国内升学产品'},
    {value: 55, label: '其他'},
    {value: 59, label: 'OPC智造局'},
    {value: 60, label: 'OPC智战枢'},
]


/*
* 年级*/
const gradeList = [  // 年级列表
    '小学一年级',
    '小学二年级',
    '小学三年级',
    '小学四年级',
    '小学五年级',
    '小学六年级',
    '美制7年级/英制8年级/初一（普高）',
    '美制8年级/英制9年级/初二（普高）',
    '美制9年级/英制10年级/初三（普高）',
    '美制10年级/英制11年级/高一（普高）',
    '美制11年级/英制12年级/高二（普高）',
    '美制12年级/英制13年级/高三（普高）',
    '大学一年级',
    '大学二年级',
    '大学三年级',
    '大学四年级',
    '研究生及以上',
    '已毕业',
    '待定'
]//学生年级 [线索、转化客户、公海]版

/*
* 年级别名词库：标准年级 + 别名数组
* 粘贴解析时，用户输入的各种写法通过此词库映射到标准年级*/
const gradeMapping = [
    {standard: '小学一年级', aliases: ['小学一年级', '1年级', '一年级', '小一', '小学1年级', '小1']},
    {standard: '小学二年级', aliases: ['小学二年级', '2年级', '二年级', '小二', '小学2年级', '小2']},
    {standard: '小学三年级', aliases: ['小学三年级', '3年级', '三年级', '小三', '小学3年级', '小3']},
    {standard: '小学四年级', aliases: ['小学四年级', '4年级', '四年级', '小四', '小学4年级', '小4']},
    {standard: '小学五年级', aliases: ['小学五年级', '5年级', '五年级', '小五', '小学5年级', '小5']},
    {standard: '小学六年级', aliases: ['小学六年级', '6年级', '六年级', '小六', '小学6年级', '小6']},
    {
        standard: '美制7年级/英制8年级/初一（普高）',
        aliases: ['美制7年级/英制8年级/初一（普高）', '初一', '初1', '初中一年级', '7年级', '七年级', '美制7年级', '英制8年级','初中1年级']
    },
    {
        standard: '美制8年级/英制9年级/初二（普高）',
        aliases: ['美制8年级/英制9年级/初二（普高）', '初二', '初2', '初中二年级', '8年级', '八年级', '美制8年级', '英制9年级','初中2年级']
    },
    {
        standard: '美制9年级/英制10年级/初三（普高）',
        aliases: ['美制9年级/英制10年级/初三（普高）', '初三', '初3', '初中三年级', '9年级', '九年级', '美制9年级', '英制10年级','初中3年级']
    },
    {
        standard: '美制10年级/英制11年级/高一（普高）',
        aliases: ['美制10年级/英制11年级/高一（普高）', '高一', '高1', '高中一年级', '10年级', '十年级', '美制10年级', '英制11年级','高中1年级']
    },
    {
        standard: '美制11年级/英制12年级/高二（普高）',
        aliases: ['美制11年级/英制12年级/高二（普高）', '高二', '高2', '高中二年级', '11年级', '十一年级', '美制11年级', '英制12年级','高中2年级']
    },
    {
        standard: '美制12年级/英制13年级/高三（普高）',
        aliases: ['美制12年级/英制13年级/高三（普高）', '高三', '高3', '高中三年级', '12年级', '十二年级', '美制12年级', '英制13年级','高中3年级']
    },
    {standard: '大学一年级', aliases: ['大学一年级', '大一', '大学1年级', '大1']},
    {standard: '大学二年级', aliases: ['大学二年级', '大二', '大学2年级', '大2']},
    {standard: '大学三年级', aliases: ['大学三年级', '大三', '大学3年级', '大3']},
    {standard: '大学四年级', aliases: ['大学四年级', '大四', '大学4年级', '大4']},
    {standard: '研究生及以上', aliases: ['研究生及以上', '研究生', '硕士', '博士']},
    {standard: '已毕业', aliases: ['已毕业', '毕业']},
    {standard: '待定', aliases: ['待定', '未知']},
]

const gradeListOfB = [  // 年级列表
    '小学一年级',
    '小学二年级',
    '小学三年级',
    '小学四年级',
    '小学五年级',
    '小学六年级',
    '美制7年级/英制8年级/初一（普高）',
    '美制8年级/英制9年级/初二（普高）',
    '美制9年级/英制10年级/初三（普高）',
    '美制10年级/英制11年级/高一（普高）',
    '美制11年级/英制12年级/高二（普高）',
    '美制12年级/英制13年级/高三（普高）',
    '大学一年级',
    '大学二年级',
    '大学三年级',
    '大学四年级',
    '研究生及以上',
    '已毕业',
]//学生年级 [B端客户]版


/*升学需求*/
const eduTemandOptions = [
    '留学', '高考', '考研', '保研', '考博', '无升学需求', '待定', '就业'
]


/*省市区级联数据*/
import { areaList } from '@vant/area-data';
/*处理数据的方法*/
export function convertToTree(areaData) {
    const tree = [];
    const provinces = areaData.province_list;
    const cities = areaData.city_list;
    const counties = areaData.county_list;

    // 统计数量
    let provinceCount = 0;
    let cityCount = 0;
    let districtCount = 0;

    for (const provinceCode in provinces) {
        provinceCount++;
        const province = {
            value: provinceCode,
            label: provinces[provinceCode],
            children: []
        };

        // 查找该省份下的城市
        for (const cityCode in cities) {
            if (cityCode.startsWith(provinceCode.substring(0, 2))) {
                cityCount++;
                const city = {
                    value: cityCode,
                    label: cities[cityCode],
                    children: []
                };

                // 查找该城市下的区县
                for (const countyCode in counties) {
                    if (countyCode.startsWith(cityCode.substring(0, 4))) {
                        districtCount++;
                        city.children.push({
                            value: countyCode,
                            label: counties[countyCode]
                        });
                    }
                }

                province.children.push(city);
            }
        }

        tree.push(province);
    }
    return tree;
}
const regionData = convertToTree(areaList);

/*咨询方向*/
const directionOptions = [
    {
    value: '理工类',
    label: '理工类',
    children: [
        {
            value: '计算机',
            label: '计算机',
        },
        {
            value: '机械工程',
            label: '机械工程',
        }, {
            value: '电子工程',
            label: '电子工程',
        }, {
            value: '数学',
            label: '数学',
        }, {
            value: '物理',
            label: '物理',
        }, {
            value: '生物',
            label: '生物',
        }, {
            value: '化学',
            label: '化学',
        }, {
            value: '环境科学与工程',
            label: '环境科学与工程',
        }, {
            value: '材料与材料工程',
            label: '材料与材料工程',
        }, {
            value: '土木工程',
            label: '土木工程',
        }, {
            value: '医学公共卫生',
            label: '医学公共卫生',
        },
    ],
}, {
    value: '金融商科类',
    label: '金融商科类',
    children: [
        {
            value: '金融',
            label: '金融',
        }, {
            value: '经济',
            label: '经济',
        }, {
            value: '会计',
            label: '会计',
        }, {
            value: '管理',
            label: '管理',
        }, {
            value: '市场营销',
            label: '市场营销',
        },
    ],
}, {
    value: '人文社科类',
    label: '人文社科类',
    children: [
        {
            value: '心理',
            label: '心理',
        }, {
            value: '教育',
            label: '教育',
        }, {
            value: '社会',
            label: '社会',
        }, {
            value: '传播',
            label: '传播',
        }, {
            value: '政治',
            label: '政治',
        }, {
            value: '法学',
            label: '法学',
        }, {
            value: '语言学',
            label: '语言学',
        }, {
            value: '哲学',
            label: '哲学',
        }, {
            value: '艺术',
            label: '艺术',
        }
    ],
},
    {
        value: '其他',
        label: '其他',
        children: [
            {
                value: '其他专业科研',
                label: '其他专业科研',
            },
            {
                value: '竞赛',
                label: '竞赛',
            },
            {
                value: '实习',
                label: '实习',
            },
            {
                value: '全职',
                label: '全职',
            },
            {
                value: '访学',
                label: '访学',
            }
        ],
    }]

export default {
    projectTypeArray,
    projectTypeAllArray,
    projectTypeZeroArray,
    gradeList,
    gradeMapping,
    eduTemandOptions,
    gradeListOfB,
    directionOptions,
    regionData
}